export default function VideoTagType() {
  return <>VideoTagType</>;
}
